import React from "react";
import { CreditCard, QrCode, ShieldCheck, User, Calendar } from "lucide-react";

export default function SmartCardDashboard() {
  const cardInfo = {
    name: "Harsh Patel",
    cardNumber: "5294  7120  8845  2217",
    type: "Royal",
    tierColor: "bg-blue-700/80",
    status: "Verified",
    validity: "Lifetime",
    joined: "Jan 2026",
  };

  return (
    <div className="space-y-3 p-3 text-[0.7rem] text-white">
      {/* Header */}
      <h1 className="flex items-center gap-2 text-[0.75rem] font-semibold tracking-wide text-slate-200">
        <CreditCard className="h-[14px] w-[14px] text-blue-400" />
        SmartCard Dashboard
      </h1>

      {/* SmartCard Display */}
      <div className="flex flex-col items-center justify-between gap-3 rounded-md border border-slate-800 bg-slate-900/70 p-3 sm:flex-row">
        {/* Left: Card Info */}
        <div className="flex flex-col gap-1">
          <h2 className="text-[0.75rem] font-semibold text-slate-200">
            {cardInfo.name}
          </h2>
          <p className="mt-[2px] text-[0.65rem] text-slate-400">
            SmartCard No:
          </p>
          <p className="font-mono text-[0.7rem] tracking-widest text-blue-400">
            {cardInfo.cardNumber}
          </p>
          <p className="mt-[2px] text-[0.65rem] text-slate-500">
            Joined {cardInfo.joined}
          </p>
        </div>

        {/* Right: Status */}
        <div className="flex flex-col items-center gap-1">
          <div
            className={`rounded-full px-2 py-[2px] text-[0.65rem] font-semibold ${cardInfo.tierColor}`}
          >
            {cardInfo.type} Tier
          </div>
          <div className="flex items-center gap-1 text-[0.65rem] font-medium text-green-400">
            <ShieldCheck className="h-[11px] w-[11px]" /> {cardInfo.status}
          </div>
          <QrCode className="mt-1 h-[28px] w-[28px] text-slate-400" />
        </div>
      </div>

      {/* Info Section */}
      <div className="grid gap-2 sm:grid-cols-2">
        <InfoBox
          icon={<User className="h-[12px] w-[12px]" />}
          label="Holder"
          value={cardInfo.name}
        />
        <InfoBox
          icon={<Calendar className="h-[12px] w-[12px]" />}
          label="Validity"
          value={cardInfo.validity}
        />
      </div>
    </div>
  );
}

function InfoBox({ icon, label, value }) {
  return (
    <div className="flex items-center gap-2 rounded-md border border-slate-800 bg-slate-900/60 p-2">
      <div className="text-blue-400">{icon}</div>
      <div className="flex flex-col">
        <p className="text-[0.65rem] text-slate-400">{label}</p>
        <p className="text-[0.7rem] font-semibold text-slate-200">{value}</p>
      </div>
    </div>
  );
}
